export enum ActionTakenEnum {
  NO_ACTION = 'NO_ACTION',
  CLIENT_CALLED = 'CLIENT_CALLED',
  CLIENT_REACHED = 'CLIENT_REACHED',
}
